import { Modal, Typography } from "@papercup-ai/orizuru";
import { useAtom } from "jotai";
import { stageCompletedMessageAtom } from "../../stateManagement/atoms/studio.atom";

export const StageCompletedModal = () => {
  const [message, setMessage] = useAtom(stageCompletedMessageAtom);
  const close = () => setMessage(null);

  return (
    <Modal
      open={!!message}
      hasOverlay
      title={message?.title ?? ""}
      confirmButtonLabel={"OK"}
      confirmButtonVariant={"primary"}
      cancelButtonHidden
      draggable={false}
      resizable={false}
      closeOnInteractOutside={false}
      closeOnEscape={false}
      onConfirm={close}
      onOpenChange={close}
    >
      <Typography variant={"labelSmall"}>{message?.description}</Typography>
    </Modal>
  );
};
